import { Siren } from "lucide-react";
import { BUSINESS } from "@/lib/business";

export function EmergencyBar() {
  return (
    <div className="bg-primary text-primary-foreground text-sm">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-4 py-2 text-center font-semibold">
        <Siren className="h-4 w-4" aria-hidden />
        <span>Plumbing emergency? Call us —</span>
        <a href={BUSINESS.phoneHref} className="underline underline-offset-2 hover:opacity-90">
          {BUSINESS.phone}
        </a>
      </div>
    </div>
  );
}